import { createContext, ReactNode, useMemo, useState } from 'react';

export type SetsMode = 'aufgaben' | 'bildkarten';

export const SetsModeContext = createContext<
  { mode: SetsMode; setMode: (m: SetsMode) => void } | undefined
>(undefined);

export function SetsModeProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<SetsMode>('aufgaben');
  const value = useMemo(() => ({ mode, setMode }), [mode]);
  return (
    <SetsModeContext.Provider value={value}>
      {children}
    </SetsModeContext.Provider>
  );
}
